import type { ReactNode } from 'react';
import { ErrorState } from '@/shared/feedback';
import { styles } from '@/shared/app-stepper-form/styles';
import { StepNavigation } from '@/shared/app-stepper-form/parts/step-navigation';

/**
 * The panel's pinned footer: the submit error, then the navigation.
 *
 * Split out of `StepperPanel` so the panel stays inside the function-length
 * budget. The two belong together because they are the only parts of the panel
 * that never scroll — the error sits directly above the controls that produced
 * it, so a failed submit is explained where the user is already looking.
 */
export function StepPanelFooter({
  submitError,
  isFirst,
  isLast,
  canAdvance,
  isSubmitting,
  submitLabel,
  cancelLabel,
  onCancel,
  onBack,
  onAdvance,
  onSubmit,
}: {
  submitError: Error | null | undefined;
  isFirst: boolean;
  isLast: boolean;
  canAdvance: boolean;
  isSubmitting: boolean;
  submitLabel: string;
  cancelLabel: string;
  onCancel: () => void;
  onBack: () => void;
  onAdvance: () => void;
  onSubmit: () => void;
}): ReactNode {
  return (
    <>
      {submitError ? (
        <div className={styles.footerError}>
          <ErrorState title="Could not save" message={submitError.message} />
        </div>
      ) : null}

      <StepNavigation
        isFirst={isFirst}
        isLast={isLast}
        canAdvance={canAdvance}
        isSubmitting={isSubmitting}
        submitLabel={submitLabel}
        cancelLabel={cancelLabel}
        onCancel={onCancel}
        onBack={onBack}
        onAdvance={onAdvance}
        onSubmit={onSubmit}
      />
    </>
  );
}
